export default __webpack_public_path__ + "static/media/simple_point.bda18bcd.png";